// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  width: 100%;
`;

export const ChildComponent = styled.div<{ showTopBorder: boolean }>`
  ${({ showTopBorder, theme }) =>
    showTopBorder &&
    `
    .childComponent {
      @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
        padding-left: 0px !important;
      }
    }

     @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      padding-left: ${theme.spacing.spacing100};
     }
`}
`;
